import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Grid,
  Row,
  Col,

  Tooltip,
  OverlayTrigger,
  Button
} from "react-bootstrap";
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { Card } from "components/Card/Card.jsx";
import { userActions } from '../../../redux/actions/user-actions';
import UserList from "../Users/UserList";
import UserForm from "../Users/UserForm";
var Modal = require('react-bootstrap-modal');

class CompanyUserListPage extends Component{
  constructor(props){
    super(props);
    var { company_id } = this.props.match.params;
    var checkPermission = false;

    

    if ( (company_id === undefined) && (this.props.userAdmin.user.role_id === 2) )
      company_id = this.props.userAdmin.user.company_id
    else if ( (company_id === undefined) && (this.props.userAdmin.user.role_id === 1) )
      company_id = null;

    this.state = {
      company_id : company_id,
      checkPermission : checkPermission,
      submitted   : false,
      Title : 'Company User list',
      addModalUser: false,
      addModalUserEdit: false,
      user:{ name:'', email: '', password:'', phone:'', permission:0, company_id:company_id },
      userError : {
        nameError:'',
        emailError:'',
        passwordError:'',
        phoneError:''
      },
      users:{}
    };
    
    // let prom = new Promise(function(resolve, reject) {
      
    //   resolve('a value');
    // });
    // prom.then((value) => {
    //   console.log('return value');
    // });

    this.openModalUser = this.openModalUser.bind(this);
    this.closeModalUser = this.closeModalUser.bind(this);

    this.openModalUserEdit = this.openModalUserEdit.bind(this);
    this.closeModalUserEdit = this.closeModalUserEdit.bind(this);

    this.handleUserSubmitPar = this.handleUserSubmitPar.bind(this);
    this.handleUserEditSubmitPar = this.handleUserEditSubmitPar.bind(this);

    this.clearField = this.clearField.bind(this);

    this.deleteUser = this.deleteUser.bind(this);
    this.deleteCompanyConfirmUser = this.deleteCompanyConfirmUser.bind(this);

    this.changePrimaryUserPar = this.changePrimaryUserPar.bind(this);
  };
  
  changePrimaryUserPar(id){
    console.log('id', id);
    const { dispatch } = this.props;
    dispatch(userActions.updatePermission(id));
  }
  openModalUser(){
    this.clearField();
    this.setState({addModalUser:true});
  }
  closeModalUser(){
    this.clearField();
    this.setState({addModalUser:false});
  }
  openModalUserEdit(id){
    this.clearField();
    const { dispatch } = this.props;
    dispatch(userActions.getUser(id));
  }
  closeModalUserEdit(){
    this.clearField();
    this.setState({addModalUserEdit:false});
  }
  handleUserSubmitPar(userData){
    const { dispatch } = this.props;
    dispatch(userActions.storeUser(userData));
  }
  handleUserEditSubmitPar(userData){
    const { dispatch } = this.props;
    dispatch(userActions.editUser(userData, this.props.editUser.id));
  }
  clearField(){
    this.setState({user:{name:'', email:'', password:'', phone:'', 'permission':0, company_id:this.state.company_id}});
    this.setState({userError:{nameError:'', emailError:'', passwordError:'', phoneError:''}});
  }
  deleteUser(userId){
    const { dispatch } = this.props;
    dispatch(userActions.deleteUser(userId));
  }
  deleteCompanyConfirmUser(userId){
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            <div className="react-confirm-alert-body">
              <h3>Delete Company User</h3>
              <p className="marginFromTopPopUp" >Are you sure to delete the company user?</p>
              <div className="react-confirm-alert-button-group">
                <button onClick={onClose}>No</button>
                <button onClick={() => {
                    this.deleteUser(userId)
                    onClose()
                }}>Yes</button>
              </div>
            </div>
            
          </div>
        )
      }
    })
  }
  componentDidMount(){
    const { dispatch } = this.props;
    dispatch(userActions.getCurrentUser());
    dispatch(userActions.getUsers(this.state.company_id));
  }
  componentWillReceiveProps(nextProps) {
      if (nextProps.editUser && !nextProps.loading){
        this.setState({user:{
          name:nextProps.editUser.name,
          email:nextProps.editUser.email,
          password:'',
          phone: nextProps.editUser.phone,
          permission: nextProps.editUser.permission,
          company_id : this.state.company_id
        }}, function(){
          this.setState({addModalUserEdit:true});
        });
      }

      if (nextProps.users){
        this.setState({users:nextProps.users});
      }
  }
  render(){
      const { user, userError, submitted } = this.state;
      const { editUser, users, userAdmin  } = this.props;
      return(
        <div className="content">
          <Grid fluid>
            <Row>
              <Col md={12}>
                  <Card
                    title="Company Users List"
                    ctTableResponsive
                    content={
                      <div>
                        {/*Add Button*/}
                        {
                          ((userAdmin.type === 'admin') || (userAdmin.type === 'company' && userAdmin.user.permission === 1)) &&
                          <Grid fluid>
                            <Row>
                                <Col md={2} sm={6} xs={12}>
                                  <div >
                                    <OverlayTrigger placement="left" overlay={<Tooltip id="tooltip">Add User</Tooltip>}>
                                      <Button type='button' className="outOfTableButton btn btn-info" onClick={this.openModalUser} ><i className="fa fa-plus" />User</Button>
                                    </OverlayTrigger>
                                  </div>
                                </Col>
                            </Row>
                          </Grid>
                        }

                        {/* Users List*/}
                        {
                          users && users.length > 0 &&
                          <UserList userProp={users} openModalUserEditProp={this.openModalUserEdit} deleteConfirmUserProp={this.deleteCompanyConfirmUser} userId={userAdmin.user.id} userTypePro="Company User" adminUserPro={userAdmin} componentPro="companyUser" changePrimaryUserParPro={this.changePrimaryUserPar}/>
                        }
                        
                        {/* Users Not Found */}
                        {
                          users && users.length === 0 &&
                          <Grid fluid>
                            <Row>
                                <Col md={8}>
                                  <h4>No Company User Found</h4>
                                </Col>
                            </Row>
                          </Grid>
                        }

                        {/*Add User Modal Start*/}
                        <Modal show={this.state.addModalUser} onHide={this.closeModalUser} aria-labelledby="ModalHeader" >
                          <Modal.Header closeButton>
                            <Modal.Title id='ModalHeader'>Add Company User</Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                          <div className="row">
                            <div className="col-md-12">
                              <UserForm closeModalUserEditPro={this.closeModalUserEdit} closeModalUserPro={this.closeModalUser} formTypePro="add"  userPro={user}      userErrorPro=''          submittedPro={submitted} adminUserPro={userAdmin}  handleUserSubmitParPro={this.handleUserSubmitPar}  handleUserEditSubmitParPro={this.handleUserEditSubmitPar} componentPro="companyUser" />
                            </div>
                            
                            </div>
                          </Modal.Body>
                        </Modal>
                        {/*Add User Modal End*/}

                        {/*Edit User Modal start*/}
                        { editUser &&
                          <Modal show={this.state.addModalUserEdit} onHide={this.closeModalUserEdit} aria-labelledby="ModalHeader" >
                          <Modal.Header closeButton>
                            <Modal.Title id='ModalHeader'>Edit Company User</Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            <div className="row">
                              <div className="col-md-12">
                                <UserForm closeModalUserEditPro={this.closeModalUserEdit} closeModalUserPro={this.closeModalUser} formTypePro="edit" userPro={user}  userErrorPro={userError} submittedPro={submitted} adminUserPro={userAdmin} handleUserSubmitParPro={this.handleUserSubmitPar}  handleUserEditSubmitParPro={this.handleUserEditSubmitPar} componentPro="companyUser" />
                              </div>
                            </div>
                          </Modal.Body>
                          </Modal>
                        }
                        {/*Edit User Modal End*/}
                      </div>
                    }
                />
              </Col>
            </Row>
          </Grid>
        </div>
      );
  }
}
function mapStateToProps(state) {
  const {  editUser, loading, users, addModal, editModal } = state.userReducer;
  const { userAdmin } = state.adminReducer;
  return {
    loading, editUser, users, userAdmin, addModal, editModal
  };
}
const CompanyUserList = connect(mapStateToProps)(CompanyUserListPage);
export default CompanyUserList;


// WEBPACK FOOTER //
// ./src/components/Admin/CompanyUser/CompanyUserList.jsx